/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {Object} layoutRenderOptions
 * @property {Boolean} isBackgrounRun - Indicate that the rendering is non-interactive, for example thumbnail rendering
 */

/**
 * @class LayoutAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class LayoutAPI {
		/**
		 * @deprecated Should use {@link LayoutAPI#getChildrenList} instead
		 */
		getChildren() { }


		/**
		 * @function LayoutApi#getId
		 * @deprecated Should not be exposed going forward.
		 */
		getId() { }

		/**
		 * Get layout ratio from parent layout
		 * @deprecated Should not be exposed going forward.  Can be done by getting the parent layout and then
		 * dividing 1 by the length of the getChildrenList response
		 */
		getSelfRatio() { }

		/**
		 * Get the widget API for the widget inside this layout
		 * @return {WidgetAPI} Null is returned if the layout does not contain a widget
		 * @deprecated use {@link LayoutAPI#getWidget} instead
		 */
		getWidgetAPI() { }


	}

	return LayoutAPI;
});
